var quickAddVariant = class extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", this.addToCart.bind(this));
  }

  async addToCart() {
    const variantId = this.getAttribute("data-variant-id");
    if (!variantId) return;

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Added to cart:", data);

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );

        const cartDrawer = document.getElementById("cart-drawer");
        if (cartDrawer) {
          cartDrawer.show();
        }
      } else {
        console.error("Failed to add to cart");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }
};

if (!window.customElements.get("quick-add-variant")) {
  window.customElements.define("quick-add-variant", quickAddVariant);
}

var productCardQuickAdd = class extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector("[data-product-card-quick-add-button]");
    this.closeButton = this.querySelector(
      "[data-product-card-quick-add-close-button]"
    );
    this.container = this.querySelector(
      "[data-product-card-quick-add-container]"
    );
    if (this.button && this.container) {
      this.button.addEventListener("click", (e) => {
        e.stopPropagation();
        this.container.style.opacity = "1";
        this.container.style.visibility = "visible";
      });

      this.closeButton.addEventListener("click", (e) => {
        e.stopPropagation();
        this.container.style.opacity = "0";
        this.container.style.visibility = "hidden";
      });
    }
  }
};

if (!window.customElements.get("product-card-quick-add")) {
  window.customElements.define("product-card-quick-add", productCardQuickAdd);
}

class toggleContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.readMore = this.querySelector('[data-read-more]');
    this.content = this.querySelector('[data-content]');
    this.fullContent = this.querySelector('[data-full-content]');
    this.handleTrigger = this.toggleContent.bind(this);
    
    if (this.readMore && this.fullContent && this.content) {
      this.readMore.addEventListener('click', this.handleTrigger);
    }
  }

  toggleContent() {
    this.content.style.display = "none";
    this.fullContent.style.display = "block";
  }
}

if (!window.customElements.get('toggle-content')) {
  window.customElements.define('toggle-content', toggleContent);
}